//  get localized content
var localization = require('localization');

// Return a html stripped version of the html and translate 
// string if neccessary.
//
// In some cases, such as GDPR texts, we might want to override the translation
// so it can be proccessed by the module itself. In that case, we have an autotranslate flag
// that just returns the stripped html without translating.
// Translation is default tought.
module.exports = function (html, autotranslate, cb) {

    if (typeof autotranslate === 'function') {
        cb = autotranslate;
        delete autotranslate;
    }

    var strippedHtml = html;

    strippedHtml = strippedHtml.replace(/<(\n|\r|.)*<body>/m, "");
    strippedHtml = strippedHtml.replace(/<\/body>(\n|\r|.)*/m, "");
    strippedHtml = strippedHtml.replace(/(\n|\r|.)*?</m, "<");

    if (autotranslate === false) {
        if( typeof cb == 'function' ) {
            return cb(strippedHtml);
        }
        return strippedHtml;
    }

    if( typeof cb == 'function' ) {
        localization.translate(strippedHtml, function(html) {
            cb(html);
        });
    }
    else {
        return localization.translate(strippedHtml);
    }
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/striphtml.js